import dayjs from 'dayjs'

import 'dayjs/locale/pl'
import 'dayjs/locale/en'

// we need to import correct locale when we add new language
export const formatDate = (value: { date: string; format: string }, lngCode: string) => {
  return dayjs(value.date).locale(lngCode).format(value.format)
}
